/* istanbul ignore file */
import { Theme } from 'model/Theme';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
  * {
    box-sizing: border-box;
  }

  html {
    height: 100%;
    width: 100%;
    font-size: 16px;
    text-size-adjust: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;

    font-family: ${({ theme }) => theme.fontFamilyPrimary};

    ${({ theme }) => theme.mediaXSAndAbove`
      background-color: #E9E8EC;
    `};

    @media print {
      background-color: ${({ theme }) => theme.backgroundColorShadeOne};

      @page {
        margin: 0.4in 1rem;
      }
    }
  }

  #root {
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 100%;

    @media print {
      background-color: ${({ theme }) => theme.backgroundColorShadeOne};
    }
  }

  button:focus,
  button:focus-visible,
  a:focus,
  a:focus-visible {
    outline: Highlight solid 2px;
    outline: -webkit-focus-ring-color auto 1px;
  }
`;
